import React, { useState } from 'react';
import type { WaitingStatus } from '../../types/waiting';
import styles from './WaitingActionButtons.module.css';

export type WaitingAction = 'call' | 'seat' | 'noShow' | 'cancel';

interface WaitingActionButtonsProps {
  status: WaitingStatus;
  waitingId: string;
  orderType?: 'DINE_IN' | 'TAKEOUT';
  onAction: (waitingId: string, action: WaitingAction) => Promise<void>;
}

export default function WaitingActionButtons({
  status,
  waitingId,
  orderType = 'DINE_IN',
  onAction,
}: WaitingActionButtonsProps) {
  const isTakeout = orderType === 'TAKEOUT';
  const callLabel = isTakeout ? '포장완료' : '호출';
  const seatLabel = isTakeout ? '수령완료' : '입장완료';
  const [loadingAction, setLoadingAction] = useState<WaitingAction | null>(null);

  const handleAction = async (action: WaitingAction) => {
    setLoadingAction(action);
    try {
      await onAction(waitingId, action);
    } finally {
      setLoadingAction(null);
    }
  };

  if (status === 'SEATED' || status === 'NO_SHOW' || status === 'CANCELLED') {
    return null;
  }

  if (status === 'WAITING') {
    return (
      <div className={styles.buttons}>
        <button
          type="button"
          className={`${styles.button} ${styles.callButton}`}
          onClick={() => handleAction('call')}
          disabled={loadingAction !== null}
        >
          {loadingAction === 'call' ? '처리중...' : callLabel}
        </button>
      </div>
    );
  }

  // CALLED 상태
  return (
    <div className={styles.buttons}>
      <button
        type="button"
        className={`${styles.button} ${styles.seatButton}`}
        onClick={() => handleAction('seat')}
        disabled={loadingAction !== null}
      >
        {loadingAction === 'seat' ? '처리중...' : seatLabel}
      </button>
      <button
        type="button"
        className={`${styles.button} ${styles.noShowButton}`}
        onClick={() => handleAction('noShow')}
        disabled={loadingAction !== null}
      >
        {loadingAction === 'noShow' ? '처리중...' : '노쇼'}
      </button>
      <button
        type="button"
        className={`${styles.button} ${styles.recallButton}`}
        onClick={() => handleAction('call')}
        disabled={loadingAction !== null}
      >
        {loadingAction === 'call' ? '처리중...' : isTakeout ? '재알림' : '재호출'}
      </button>
    </div>
  );
}
